
import { Children, PropsWithChildren, useEffect, useRef, useState } from "react";
import Swiper from "swiper";
import { register } from 'swiper/element/bundle';
import { SwiperProps } from "swiper/react";

register();

const BeforeAndAfterSlider = ({ children }: PropsWithChildren) => {
    const childrens = Children.toArray(children);

    const [realIndex, setRealIndex] = useState(1);
    const swiperRef = useRef() as any;

    useEffect(() => {
        const swiperContainer = swiperRef.current;

        if (!swiperContainer) return;

        const params: SwiperProps = {
            speed: 750,
            autoplay: {
                delay: 8000,
            },
            slidesPerView: 1,
            spaceBetween: 24,
            loop: false,
            pagination: {
                el: ".swiper-pagination",
                clickable: true,
                renderBullet: (index, className) => {
                    return `<div class="${className} custom-pagination-dot"></div>`;
                },
            },
            on: {
                realIndexChange: (swiper: Swiper) => {
                    setRealIndex(swiper.realIndex + 1);
                },
            },
        };

        Object.assign(swiperContainer, params);
        swiperContainer.initialize();
    }, [swiperRef])
    
    return(
        <div className="relative">
            <swiper-container ref={swiperRef} init={false} pagination className="h-auto">
                {childrens.length > 0 && childrens.map((child, i) => (
                    <swiper-slide key={i}>
                        {child}
                    </swiper-slide>
                ))}
            </swiper-container>
            <div className="px-20 w-full mt-4">
                <div className="flex gap-x-3">
                    <div className="swiper-pagination flex gap-x-3 justify-center mx-auto"></div>
                </div>
            </div>
        </div>
    )
}

export default BeforeAndAfterSlider;